import { Form, Input, Select } from "antd";
import Label from "../../components/label/label.component";
import CustomInput from "../../components/custom-input/custom-input.component";
import TextArea from "antd/es/input/TextArea";
import clsx from "clsx";
import ReactCountryFlag from "react-country-flag";
import { useState } from "react";

const { Option } = Select;

const BankForm: React.FC<any> = ({
  bank,
  index,
  onSubmit,
  countriesList,
  banksData,
  standingData,
  currenciesList,
  setSelectedBank,
  setOpenDeleteModal,
}) => {
  const [form] = Form.useForm();
  const [selectedCountryId, setSelectedCountryId] = useState<any>(bank?.accountCountry?.id || bank?.accountCountryId);

  return (
    <Form
      className="add-edit-form"
      scrollToFirstError={true}
      name={`formPerson${index}`}
      form={form}
      initialValues={{
        id: bank?.id,
        accountCountryId: bank?.accountCountry?.id,
        bankId: bank?.bankId,
        currencyId: bank?.currencyId,
        accountNumber: bank?.accountNumber,
        ibanNumber: bank?.ibanNumber,
        swiftCode: bank?.swiftCode,
        additionalInfo: bank?.additionalInfo,
      }}
    >
      <div className="fields flex justify-between flex-wrap">
        <div className="field flex-col hidden">
          <Label text="ID" />
          <Form.Item
            name="id"
            hidden
            rules={[
              {
                required: true,
                message: "Please input Full name!",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </div>
        <div className="field flex column">
          <Label text="Country" />
          <Form.Item
            name="accountCountryId"
            validateTrigger={["onChange", "onBlur"]}
            rules={[
              {
                required: true,
                message: "Please select country!",
              },
            ]}
          >
            <Select placeholder="Select Country" allowClear showSearch
              onChange={(value) => {
                setSelectedCountryId(value);
                form.setFieldsValue({
                  bankId: undefined,
                  currencyId: undefined,
                  ibanNumber: undefined,
                });
              }}
            >
              {countriesList?.map((country: any) => (
                <Option value={country.id} key={country.nameEn}>
                  <div className="flex items-center gap-1">
                    <ReactCountryFlag
                      style={{
                        fontSize: "24px",
                        marginInlineEnd: "8px",
                      }}
                      countryCode={country?.countryCode}
                      svg
                    />
                    <span>{country.nameEn}</span>
                  </div>
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <div className="field flex column">
          <Label text="Bank Name" />
          <Form.Item
            name="bankId"
            validateTrigger={["onChange", "onBlur"]}
            rules={[
              {
                required: true,
                message: "Please select bank name!",
              },
            ]}
          >
            <Select
              placeholder="Select Bank Name"
              options={banksData?.filter((item: any) => item.countryid === selectedCountryId && (item.branch?.toLowerCase() === 'gc' || item?.branch?.toLowerCase() === 'sa'))?.map((item: any) => {
                return { value: item.id, label: item.bankName };
              })}
            />
          </Form.Item>
        </div>
        <div className="field flex column">
          <Label text="Currency" />
          <Form.Item
            name="currencyId"
            validateTrigger={["onChange", "onBlur"]}
            rules={[
              {
                required: true,
                message: "Please select currency!",
              },
            ]}
          >
            <Select
              placeholder="Select currency"
              allowClear
              showSearch
              filterOption={(input, option) =>
                (option?.children as any)?.props?.children
                  ?.toString()
                  ?.toLowerCase()
                  ?.includes(input.toLowerCase())
              }
            >
              {currenciesList?.map((country: any) => (
                <Option value={country.id} key={country.currencyCode}>
                  <span>{country.currencyCode} - {country.longNameEn}</span>
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <div className="field flex column">
          <Label text="Account Number" />
          <Form.Item
            name="accountNumber"
            validateTrigger={["onChange", "onBlur"]}
            rules={[
              {
                required: true,
                message: "Please enter account number!",
              },
            ]}
          >
            <CustomInput placeholder="enter Account Number" />
          </Form.Item>
        </div>
        <div className="field flex column">
          <Label text="IBAN No." />
          <Form.Item name="ibanNumber" validateTrigger={["onChange", "onBlur"]}>
            <CustomInput placeholder="enter IBAN No." />
          </Form.Item>
        </div>
        <div className="field flex column">
          <Label text="SWIFT Code" />
          <Form.Item name="swiftCode" validateTrigger={["onChange", "onBlur"]}>
            <CustomInput placeholder="enter SWIFT Code" />
          </Form.Item>
        </div>
        <div className="fields flex column">
          <Label text="Additional Information" />
          <Form.Item
            name="additionalInfo"
            validateTrigger={["onChange", "onBlur"]}
          >
            <TextArea rows={4} placeholder="Enter additional information" />
          </Form.Item>
        </div>
      </div>
      <div className="flex w-full flex-wrap items-center justify-end mt-7 border-t-[1px] border-gray-900 pt-5">
        <div
          className={clsx(
            "flex items-center w-[70%] md:w-[48%]",
            bank?.id ? "justify-between" : "justify-end"
          )}
        >
          {bank?.id && (
            <button
              type="button"
              onClick={() => {
                setSelectedBank(bank);
                setOpenDeleteModal(true);
              }}
              className="rounded-lg bg-red-200 text-white w-[48%] py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-red-200"
            >
              Delete
            </button>
          )}
          <button
            type="button"
            className="disabled:opacity-50 disabled:cursor-not-allowed rounded-lg bg-blue-500 w-[48%] py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-blue-500 text-white"
            onClick={() => onSubmit(form.getFieldsValue())}
          >
            Save
          </button>
        </div>
      </div>
    </Form>
  );
};

export default BankForm;
